export default __webpack_public_path__ + "static/media/rocket_anim_141.5ee22bf0.png";